import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { UserActivationActionTypeEnum } from "../../ActivationAction";

@Component
export default class BotFeedbackLimitsMixin extends Vue {
  @Prop({ type: Array, default: () => [] }) limitTypes!: Array<UserActivationActionTypeEnum>

  limitWarnMessagesTranslationKeys = {
    [UserActivationActionTypeEnum.Flow]: 'action_flow_has_limit_alert_message',
    [UserActivationActionTypeEnum.Message]: 'action_message_has_limit_alert_message'
  }

  hasLimit(type: UserActivationActionTypeEnum) {
    return this.limitTypes && !!this.limitTypes.length && this.limitTypes.includes(type)
  }
}
